import { Product } from "@omni/types/api/product/bff/product.model";
import { ProductFieldSet } from "@omni/types/api/product/bff/shared/enums/productFieldSet.enum";
import { cn } from "@omni/utils/styles";
import { useState } from "react";

import { Col } from "@/components/General/Grid/col.component";
import { Row } from "@/components/General/Grid/row.component";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";

import { InfoBlockAnchor } from "../../components/infoBlockAnchor.component";
import { InfoBlockContent } from "../../components/infoBlockContent.component";
import { InfoBlockHeading } from "../../components/infoBlockHeading.component";
import { InfoBlockWrapper } from "../../components/infoBlockWrapper.component";
import { getAllDocuments } from "../../helpers";
import { DocumentationList } from "./documentationList/documentationList.component";

type DocumentListProps = {
    product: Product<ProductFieldSet.Full>;
};

const DocumentList = ({ product }: DocumentListProps) => {
    const { t } = useGranite();
    const [showMobileMore, setShowMobileMore] = useState(false);

    const allDocuments = getAllDocuments(product);

    return (
        <InfoBlockWrapper showMobileMore={showMobileMore}>
            <InfoBlockHeading
                title={t("productDetail.anchor.title.documentation")}
                onClick={() => setShowMobileMore((state) => !state)}
            />
            <InfoBlockContent>
                <Row>
                    <Col>
                        <InfoBlockAnchor id={"info"} />
                        <h4
                            className={cn(
                                "tw:mb-4 tw:font-bold anchor--pdp-info-nav"
                            )}
                        >
                            <span>
                                {t("productDetail.anchor.title.documentation")}
                            </span>
                        </h4>
                        <section className={cn("tw:mb-4")}>
                            <DocumentationList docMap={allDocuments} />
                        </section>
                    </Col>
                </Row>
            </InfoBlockContent>
        </InfoBlockWrapper>
    );
};

export { DocumentList };
